<template>
  <section class="service-workflow">
    <div class="service-workflow-inner">
      <h2 class="workflow-title">How Our Service Works?</h2>
      <div class="workflow-steps">
        <div v-for="(step, index) in steps" :key="index" class="workflow-step">
          <div class="step-icon">
            <img class="icon-default" :src="step.icon" :alt="step.title">
            <img class="icon-active" :src="step.activeIcon" :alt="step.title">
          </div>
          <div class="step-title">{{ step.title }}</div>
          <div class="step-desc" v-if="step.desc" :class="{ highlight: step.highlight }" @click="handle_buy(step.highlight)">
            {{ step.desc }}
          </div>
          <div v-if="index < steps.length - 1" class="step-arrow">-&gt;</div>
        </div>
      </div>
      <section v-if="displayedHolidays.length" class="upcoming-holidays" aria-labelledby="upcoming-holidays-title">
        <h3 id="upcoming-holidays-title" class="holidays-title">Upcoming holidays</h3>
        <div class="holidays-grid">
          <article v-for="(holiday, index) in displayedHolidays" :key="holiday.date + holiday.country + index" class="holiday-item">
            <div class="holiday-date">{{ formatHolidayDate(holiday) }}</div>
            <div class="holiday-country">{{ holiday.country }}</div>
            <div class="holiday-name">{{ holiday.title }}</div>
          </article>
        </div>
      </section>
      <div class="workflow-footer">
        <div class="delivery-info">
          <div class="years-badge">
            <span class="years-number">10</span>
            <span class="years-text">years</span>
          </div>
          <div class="worldwide-content">
            <div class="worldwide-title">Worldwide delivery</div>
            <div class="worldwide-desc">BuybuyGENUINE supplies new OEM (genuine) parts and ships worldwide with fast
              delivery and reasonable cost to the customer.</div>
          </div>
        </div>
        <div class="paypal-wrap">
          <img class="paypal-logo paypal-default" src="@/assets/编组(21).png" alt="PayPal">
          <img class="paypal-logo paypal-active" src="@/assets/编组备份 5.png" alt="PayPal">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServiceWorkflow',
  data() {
    return {
      steps: [
        {
          title: 'Create your order',
          desc: 'How to buy?',
          icon: require('@/assets/编组(17).png'),
          activeIcon: require('@/assets/cart1.png'),
          highlight: true
        },
        {
          title: 'Suppliers are contacted',
          desc: 'Manufacturers as well',
          icon: require('@/assets/编组(19).png'),
          activeIcon: require('@/assets/编组(8).png'),
          highlight: false
        },
        {
          title: 'We receive your items',
          desc: 'At our warehouse',
          icon: require('@/assets/编组(14).png'),
          activeIcon: require('@/assets/编组(4).png'),
          highlight: false
        },
        {
          title: 'Pay delivery fee',
          desc: 'Items checked',
          icon: require('@/assets/编组(15).png'),
          activeIcon: require('@/assets/编组(5).png'),
          highlight: false
        },
        {
          title: 'Your order is shipped',
          desc: 'Safely packed',
          icon: require('@/assets/编组(16).png'),
          activeIcon: require('@/assets/编组(6).png'),
          highlight: false
        },
        {
          title: 'Delivered!',
          desc: '',
          icon: require('@/assets/编组(20).png'),
          activeIcon: require('@/assets/编组(9).png'),
          highlight: false
        }
      ],
      holidays: []
    }
  },
  computed: {
    displayedHolidays() {
      return this.holidays 
    }
  },
  mounted() {
    this.fetchHolidays()
  },
  methods:{
    async fetchHolidays() {
      try {
        const res = await this.$api({
          url: 'Content/settings',
          method: 'get',
          data: { group: 'basic' }
        })
        const payload = res && res.data ? res.data : res
        const data = payload && payload.data && !Array.isArray(payload.data)
          ? payload.data
          : payload
        let holidayList = data && data.holiday_list
        if (typeof holidayList === 'string') {
          try {
            holidayList = JSON.parse(holidayList)
          } catch (e) {
            holidayList = []
          }
        }
        this.holidays = Array.isArray(holidayList)
          ? holidayList.filter(item => item && (item.date || item.en_date || item.title))
          : []
      } catch (err) {
        this.holidays = []
        console.error('Failed to fetch upcoming holidays:', err)
      }
    },
    formatHolidayDate(holiday) {
      const value = holiday && holiday.date
      if (!value) return holiday && holiday.en_date ? holiday.en_date : ''

      const match = String(value).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
      if (!match) return holiday.en_date || value

      const year = Number(match[1])
      const month = Number(match[2])
      const day = Number(match[3])
      const date = new Date(year, month - 1, day)
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return holiday.en_date || value
      }

      const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${weekdays[date.getDay()]}, ${day} ${months[date.getMonth()]}`
    },
    handle_buy(show){
      if(show){
        this.$router.push('/help')
      }
      
    }
  },

}
</script>

<style scoped>
.service-workflow {
  width: 100%;
  padding: 0 20px 42px;
  background-color: #fff;
}

.service-workflow-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.workflow-title {
  margin: 0 0 42px;
  color: #222;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.workflow-steps {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
}

.workflow-step {
  min-width: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.step-icon {
  width: 82px;
  height: 82px;
  margin-bottom: 18px;
  position: relative;
}

.step-icon img {
  width: 82px;
  height: 82px;
  display: block;
  object-fit: contain;
  transition: opacity 0.18s;
}

.icon-active {
  position: absolute;
  inset: 0;
  opacity: 0;
}

.workflow-step:hover .icon-default {
  opacity: 0;
}

.workflow-step:hover .icon-active {
  opacity: 1;
}

.step-title {
  min-height: 20px;
  color: #333;
  font-size: 15px;
  line-height: 1.35;
}

.step-desc {
  margin-top: 6px;
  color: #8d8d8d;
  font-size: 14px;
  line-height: 1.35;
}

.step-desc.highlight {
  color: #ff5a1f;
  cursor: pointer;
}

.step-arrow {
  position: absolute;
  top: 24px;
  right: -25px;
  color: #aaa;
  font-size: 28px;
  font-weight: 300;
}

.upcoming-holidays {
  max-width: 640px;
  margin-top: 46px;
}

.holidays-title {
  margin: 0 0 20px;
  color: #222;
  font-size: 21px;
  font-weight: 400;
  line-height: 1.25;
}

.holidays-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
}

.holiday-item {
  min-width: 0;
}

.holiday-date,
.holiday-country,
.holiday-name {
  overflow-wrap: anywhere;
}

.holiday-date {
  margin-bottom: 10px;
  color: #333;
  font-size: 16px;
  line-height: 1.3;
}

.holiday-country {
  margin-bottom: 3px;
  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.holiday-name {
  color: #777;
  font-size: 15px;
  line-height: 1.35;
}

.workflow-footer {
  margin-top: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.delivery-info {
  display: flex;
  align-items: center;
  gap: 22px;
  max-width: 620px;
}

.years-badge {
  width: 70px;
  height: 70px;
  border: 2px solid #ff5a1f;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ff5a1f;
  flex: 0 0 auto;
}

.years-number {
  font-size: 26px;
  font-weight: 400;
  line-height: 1;
}

.years-text {
  font-size: 14px;
  line-height: 1;
}

.worldwide-title {
  margin-bottom: 8px;
  color: #333;
  font-size: 18px;
  font-weight: 700;
  transition: color 0.18s;
}

.worldwide-desc {
  color: #555;
  font-size: 12px;
  line-height: 1.45;
  transition: color 0.18s;
}

.delivery-info:hover .worldwide-title,
.delivery-info:hover .worldwide-desc {
  /* color: #ff5a1f; */
}

.paypal-wrap {
  width: 201px;
  height: 49px;
  position: relative;
}

.paypal-logo {
  width: 201px;
  height: 49px;
  display: block;
  object-fit: contain;
  transition: opacity 0.18s;
}

.paypal-active {
  position: absolute;
  inset: 0;
  opacity: 0;
}

.paypal-wrap:hover .paypal-default {
  opacity: 0;
}

.paypal-wrap:hover .paypal-active {
  opacity: 1;
}

@media (max-width: 992px) {
  .workflow-steps {
    grid-template-columns: repeat(3, 1fr);
    row-gap: 42px;
  }

  .step-arrow {
    display: none;
  }
}

@media (max-width: 640px) {
  .workflow-steps {
    grid-template-columns: 1fr;
  }

  .upcoming-holidays {
    margin-top: 38px;
  }

  .holidays-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .workflow-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 28px;
  }
}
</style>
